// extracted by mini-css-extract-plugin
export default {"container":"styles_container__V+4KX"};